module.exports = __webpack_public_path__ + "static/img/1DgetcertifiedXgoxpJzyqsbjBoOPVBzNnfm4XY.e900ba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/originalframerhtml_files/1DgetcertifiedXgoxpJzyqsbjBoOPVBzNnfm4XY.jpg
// module id = LL0W
// module chunks = 62